import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BookingSearchRouting } from './booking-search.routing';
import { BookingSearchComponent } from './booking-search.component';
import { SashaBreadcrumbModule } from '../../shared/components/breadcrumb/sasha-breacrumb.module';
import { HelperService } from 'app_sasha/shared/services/helper.service';
import { BookingSearchFormModule } from '../../shared/components/booking-search-form/booking-search-form.module';
import { TitleServiceModule } from 'app_sasha/shared/services/title/title-service.module';

@NgModule({
    imports: [
        CommonModule,
        BookingSearchRouting,
        SashaBreadcrumbModule,
        BookingSearchFormModule,
        TitleServiceModule,
    ],
    declarations: [
        BookingSearchComponent,
    ],
    providers: [
        HelperService,
    ]
})
export class BookingSearchModule { }
